<template lang="pug">
.task-container(
  v-if="showTask"
  :class="{'new-module': newModule}"
)
  .header
    .title {{ moduleTitle }}
  bounty-coupon-alipay(
    :new-module="newModule",
    :data="data",
    :preparing="preparing"
  )
</template>

<script>
import { env } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { getTokenAndKey, getCityInfo, debounce } from '@/utils/index';
import { mapTaskV2, mapBusinessInfo } from '@/utils/mappers';
import { TASK_STATUS_V2 } from '@/const/task';
import { getTaskListV2 } from '@/api/bounty';
import { getVersion } from '@/utils/systemCode';
import { isPreRender } from '../../../utils';
import BountyCouponAlipay from './bounty-coupon-alipay.vue';
import { FULI_MODULE_NAV } from '../consts';

export default {
  name: 'BountyTask',
  components: {
    BountyCouponAlipay,
  },
  props: {
    newModule: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: [],
      preparing: true,
      showTask: true,
    };
  },
  computed: {
    moduleTitle() {
      if (this.newModule) {
        return '赚奖励金';
      }
      return '做任务赚奖励金';
    },
  },
  mounted() {
    if (isPreRender()) {
      return;
    }
    if (env.isEasyBikeApp) {
      setTimeout(() => {
        window.addEventListener('pageshow', () => {
          this.getTasks();
        });
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            this.getTasks();
          }
        });
      });
    } else if (env.isAliMP || env.isAliMPMonitor) {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.getTasks();
        }
      });
    }

    setTimeout(() => {
      if (this.preparing) {
        this.preparing = false;
      }
    }, 2000);
  },
  methods: {
    start() {
      return this.getTasks();
    },
    getTasks: debounce(async function foo() {
      const { token } = await getTokenAndKey();
      const cityInfo = await getCityInfo();
      return getTaskListV2({
        token,
        channelId: env.platformCode,
        sceneNameEn: 'platform_points',
        subSceneNameEn: 'platform_points_pointshp',
        taskStatusList: [TASK_STATUS_V2.INIT, TASK_STATUS_V2.RUNNING],
        queryUnrewardedTasks: true,
        version: await getVersion(),
        ...cityInfo,
      })
        .then((v) => {
          if (v && v.data && v.data.taskList && v.data.taskList.length) {
            this.data = v.data.taskList.map(mapTaskV2);
            (this.data || []).forEach((task) => {
              UBT.moduleExpose({
                pageId: 'platform_bounty',
                categoryId: 'platform',
                moduleId: 'platform_click.task',
                contentId: 'platform_click.task',
                exposureTimes: '1',
                businessInfo: {},
              });
              UBT.moduleExpose({
                pageId: 'platform_bounty',
                categoryId: 'market',
                moduleId: 'market_task',
                contentId: 'market_task',
                exposureTimes: '1',
                businessInfo: mapBusinessInfo(task),
              });
            });
          } else {
            this.showTask = false;
          }
        })
        .catch((e) => {
          if (e) {
            this.showTask = false;
          }
        })
        .then(() => {
          this.preparing = false;
          if (!this.showTask) {
            this.$emit('hideTab', FULI_MODULE_NAV.welfare_task_new);
          }
        });
    }),
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

.task-container {
  width: 100%;
  padding: 0.2rem 0.16rem 0.16rem;
  background-color: white;
  border-radius: 0.08rem;
  box-shadow: 0 0.03rem 0.06rem 0 rgba(0, 0, 0, 0.06);

  .header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .title {
      margin-bottom: 0.2rem;
      display: flex;
      font-size: 0.18rem;
      font-weight: 500;
      color: #242729;
    }
  }

  &.new-module {
    padding: 0.16rem;

    .header {
      .title {
        margin-bottom: 0.16rem;
        color: #333;
        font-size: 0.16rem;
      }
    }
  }
}
</style>
